// extracted by mini-css-extract-plugin
export default {"block":"Loading_block__0XF-E","full":"Loading_full__M3Qx2"};